import getMetaTagContent from '../../../../helpers/getMetaTagContent';
import { ES6_BROWSER } from '../../../../helpers/metaTagIdentifiers';
import supportsES6 from './supportsES6';

let suspected_spoof;

/**
 * Add extra metadata to the record.
 */
export default function enrich(record) {
    suspected_spoof = typeof suspected_spoof === 'undefined'
        ? (supportsES6() === false && getMetaTagContent(ES6_BROWSER) === 'true')
        : suspected_spoof;
    record.meta = record.meta || {};
    record.meta.suspected_spoof = suspected_spoof;
    record.meta.readyState = document.readyState;
    try {
        record.meta.age = performance.now() / 1000;
    } catch (e) {
        // ignore
    }
    record.level = record.level || 'error';
    record.severity = record.severity || 5;
    record.pipeline = 'UNHANDLED_ERRORS_PIPELINE';
    return record;
}
